import React, { Component } from "react";
import { Redirect } from "react-router";
import { connect } from "react-redux";

import { checkAndRenewTokens } from "../../../redux/actions/auth";

const mapStateToProps = state => ({
  isAuthorized: state.auth.isAuthorized,
});

const mapDispatchToProps = dispatch => ({
  checkAndRenewTokens: () => dispatch(checkAndRenewTokens()),
});

export default function (WrappedComponent) {
  class AuthWrapper extends Component {
    
    componentDidMount = () => {
      const { checkAndRenewTokens } = this.props;
      checkAndRenewTokens();
    }
   

    render() {
      const { isAuthorized } = this.props;

      const prevUrl = this.props.location.pathname;
      localStorage.setItem("prevUrl", prevUrl);

      return isAuthorized ? (
        <WrappedComponent {...this.props} />
      ) : (
        <Redirect to={"/"} />
      );
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)(AuthWrapper); 
}
